import Box from "@mui/material/Box";
import MUIDataTable from "mui-datatables";

import TableSkeleton from "../../../../components/skeletons/TableSkeleton";

import { getColumns, getOptions } from "./config";

import { useTranslation } from "react-i18next";
import { useGetCompanyWithIdUsersQuery } from "../../../user/userApiSlice";

const List = ({ companyId }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const {
		data: users,
		error,
		isLoading,
		isFetching,
	} = useGetCompanyWithIdUsersQuery(companyId);

	if (isLoading || isFetching) {
		return (
			<Box sx={{ mt: "64px" }}>
				<TableSkeleton />
			</Box>
		);
	}

	const columns = getColumns(t, lang);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table super-admin users-table"
			data={users.map((user) => ({ ...user, companyId }))}
			columns={columns}
			options={options}
		/>
	);
};

export default List;
